module.exports = "/assets/6be07942fd57a3f2bb948f19678d5df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8E.png
// module id = 1132
// module chunks = 0